var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 30",
    style: {
      enableBackground: "new 0 0 58.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,16l1.1-0.1c0.1,0.6,0.3,1.1,0.6,1.4c0.3,0.3,0.7,0.4,1.1,0.4c0.5,0,1-0.2,1.3-0.5c0.4-0.4,0.5-0.8,0.5-1.3 c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.2,0-0.5,0-0.8,0.1l0.1-1l0.2,0c0.5,0,0.9-0.1,1.3-0.4c0.4-0.2,0.6-0.6,0.6-1.1 c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.5,0.7-0.6,1.2l-1.1-0.2C6.9,11,7.2,10.4,7.7,10 c0.5-0.4,1.1-0.6,1.8-0.6c0.5,0,0.9,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.1,0.7-0.3,1.1 c-0.2,0.3-0.5,0.6-0.9,0.8c0.5,0.1,0.9,0.4,1.2,0.8s0.4,0.9,0.4,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.3,0.8-2.2,0.8 c-0.8,0-1.4-0.2-2-0.7C7,17.4,6.7,16.8,6.6,16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 0.5025 15.8753)",
    width: 1,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 20.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -8.8487 9.7122)",
    width: 28.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,25.9H4V3.8h22.5V25.9z M4.9,25h20.8V4.6H4.9V25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: -6.7,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 15.6732 41.2132)",
    width: 1,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -5.0059 24.0702)",
    width: 28.5,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7,30h-30V0h30V30z M29.7,29h28.1V1H29.7V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,25.9H32.8V3.8h22.5V25.9z M33.6,25h20.8V4.6H33.6V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk30);
export default __webpack_public_path__ + "static/media/ak_3_0.0aa525df6be16b5571d447f14b949d46.svg";
export { ForwardRef as ReactComponent };